import request from '@/utils/ajax';

interface WebSite {
  status: number;
  id: string;
  name: string;
  article_count: string;
  image: string;
}

interface PicList {
  url: string;
  height: number;
  width: number;
}

interface ShareInfo {
  in_share_id: string;
  in_share_type: number;
  in_share_title: string;
  in_share_desc: string;
  in_share_contentURL: string;
  in_share_imageURL: string;
}

interface Origin {
  url: string;
  height: number;
  width: number;
}

export interface ScientificResource {
  webSite: WebSite; // 有些接口拼写大小写导致和website名称不一致
  website: WebSite;
  id: string;
  title: string;
  show_mode: string;
  is_stick: number;
  description: string;
  source: string;
  comment_count: number;
  praise_count: string;
  content: string;
  is_praise: number;
  create_time: string;
  publish_date: string;
  pic_list: PicList[];
  video_duration: string;
  audio_count: number;
  movie_url: string;
  status: number;
  redirect: string;
  type: number;
  original: number;
  classify: number;
  special_type: number;
  share_info: ShareInfo;
  origin: Origin[];
  img_url: string[];
  duration: string; // 音频使用
  task_id: string;
  desc: string;
}

// 科普号主页
export function reqWebsiteinfo(params?: { id: string }) {
  return request.request({
    url: '/scientificwebsite/websiteinfo',
    method: 'get',
    params,
  });
}
// 科普号主页资讯列表
export function reqScientificwebsiteList(params: {
  id: string; // 科普号id
  page: number;
  size?: number;
  type?: number; // 类型id
  column_id?: string; // 栏目id
}) {
  return request.request<
    PageResult<ScientificResource>,
    HttpResponse<PageResult<ScientificResource>>
  >({
    url: '/scientificwebsite/list',
    method: 'get',
    params,
  });
}

// 科普号主页精彩专题  /special/specialSelectedList

export function reqSpecialSelectedList(data?: { page: number }) {
  return request.request({
    url: '/special/specialSelectedList',
    method: 'post',
    data: data,
  });
}

export interface KepuhaoActivityItem {
  id: string;
  type: number;
  release_type: number;
  city: string;
  image: string;
  title: string;
  region: string;
  address: string;
  pro_city: string;
  activity_typeval: number;
  year: string;
  create_at: string;
  create_at_1: string;
  create_at_3: string;
  create_at_2: string;
  start_time: number;
  end_time: number;
  review_status: number;
  is_recommend: number;
  uid: number;
  ct_time: string;
}

// 科普号主页活动
export function reqKepuhaoActivity(params?: {
  id?: string; // 科普号id
  page?: number;
}) {
  return request.request<
    PageResult<KepuhaoActivityItem>,
    HttpResponse<PageResult<KepuhaoActivityItem>>
  >({
    url: '/comactivity/kepuhaoActivity',
    method: 'get',
    params,
  });
}

// 添加评论 /comment/addComment
interface Comment {
  /**
   * 资讯id
   */
  ar_id?: string;
  /**
   * 评论类型：0-游客、1-匿名、2-会员
   */
  comment_type?: string;
  /**
   * 评论内容
   */
  content?: string;
  /**
   * 是否是表情 1是 0不是
   */
  emoticon?: string;
  /**
   * 回复某个评论的id
   */
  re_pid?: string;
  /**
   * 评论类型
   */
  type?: number;
  /**
   * spm
   */
  spm?: string;
  /**
   * scm
   */
  scm?: string;
  /**
   * 请求id
   */
  request_id?: string;
  /**
   * 设备id
   */
  unique_identifier?: string;
  /**
   * 网络
   */
  network?: string;
}
export function reqAddComment(data?: Comment) {
  return request.request({
    url: '/comment/addComment',
    method: 'post',
    data: data,
  });
}

export interface FollowItem {
  website: {
    id: string;
    name: string;
    avatar: string;
  };
  id: string;
  title: string;
  review_count: string;
  content: string;
  show_content: string;
  desc: string;
  publish_date: string;
  requestTime: number;
  img_url: string[];
  video_duration: string;
  audio_count: number;
  movie_url: string;
  type: number;
  redirect: string;
  classify: number;
  show_mode: string;
  share_info: {
    in_share_id: string;
    in_share_type: number;
    in_share_title: string;
    in_share_desc: string;
    in_share_contentURL: string;
    in_share_imageURL: string;
  };
  scm: string;
  request_id: string;
}
// 关注资源列表  /scientificwebsite/indexfollowlist
export function reqIndexfollowlist(data?: { page: number }) {
  return request.request<
    { info: string; list: FollowItem[] },
    HttpResponse<{ info: string; list: FollowItem[] }>
  >({
    url: '/scientificwebsite/indexfollowlist',
    method: 'post',
    data: data,
  });
}

// 关注我关注的科普号
export function reqMywebsitelist() {
  return request.request<
    {
      id: string;
      image: string;
      name: string;
      status: number;
      scm: string;
      request_id: string;
    }[],
    HttpResponse<
      {
        id: string;
        image: string;
        name: string;
        status: number;
        scm: string;
        request_id: string;
      }[]
    >
  >({
    url: '/scientificwebsite/mywebsitelist',
    method: 'get',
  });
}

// 获取省 /sciencer/province
export function reqProvince() {
  return request.request({
    url: '/sciencer/province',
    method: 'post',
  });
}
// 获取市区 /sciencer/city
export function reqCity(data: { province_code: number }) {
  return request.request({
    url: '/sciencer/city',
    method: 'post',
    data,
  });
}
// 获取区县/sciencer/county
export function reqCounty(data: { city_code: number }) {
  return request.request({
    url: '/sciencer/county',
    method: 'post',
    data,
  });
}
// 获取街道 /sciencer/town
export function reqTown(data: { county_code: number }) {
  return request.request({
    url: '/sciencer/town',
    method: 'post',
    data,
  });
}

// 查询某个科普教育基地下的评价列表
export function reqGetApplicantJudgeList(data?: {
  applicant_id: string;
  page: number;
}) {
  return request.request({
    url: '/applicant/getApplicantJudgeList',
    method: 'post',
    data,
  });
}

// 查询某个科普教育基地下相关活动

export function reqGetApplicantActList(data?: { applicant_id: string }) {
  return request.request({
    url: '/comactivity/getApplicantActList',
    method: 'post',
    data,
  });
}
// 获取10个省份
export function reqGetChannelProList() {
  return request.request<
    Array<{
      name_val: string;
      province_code: string;
      sort_name: string;
    }>,
    HttpResponse<
      Array<{
        name_val: string;
        province_code: string;
        sort_name: string;
      }>
    >
  >({
    url: '/index/getChannelProList',
    method: 'get',
  });
}
